import React from "react";
import { Link } from "react-router-dom";
import Footer from "../includes/Footer";
import Sidebar from "../includes/Sidebar";
import "../AdminSingle/singleCSS.css";

export default function Dashboard() {
  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <Sidebar />

          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="card radius-10 border-0 border-start border-orange border-3">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="">
                      <h4 className="mb-1">Manage RSA</h4>
                      <Link to="/import-rsa" className="manage-btns">
                        Manage RSA
                      </Link>
                      <Link to="/import-rsa" className="manage-btns">
                        Add New RSA
                      </Link>
                    </div>
                    <div className="ms-auto widget-icon bg-orange text-white">
                      <i className="bi bi-person-plus-fill"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-4">
              <div className="card radius-10 border-0 border-start border-orange border-3">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="">
                      <h4 className="mb-1"> Registered Users </h4>
                      <Link to="/registered-users" className="manage-btns">
                        Manage Users
                      </Link>
                    </div>
                    <div className="ms-auto widget-icon bg-orange text-white">
                      <i className="bi bi-person-fill"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
